import styles from './DailyConversations.module.scss'

const StatsPanel = ({ statistics }) => {
  return (
    <div className={styles.statsPanel}>
      <div className={styles.statsRow}>
        <div className={styles.statItem}>
          <div className={styles.statValue}>{statistics.total}</div>
          <div className={styles.statLabel}>Total</div>
        </div>
        <div className={styles.statItem}>
          <div className={styles.statValue}>{statistics.unreviewed}</div>
          <div className={styles.statLabel}>Unreviewed</div>
        </div>
        <div className={styles.statItem}>
          <div className={styles.statValue}>{statistics.flagged}</div>
          <div className={styles.statLabel}>Flagged</div>
        </div>
        <div className={styles.statItem}>
          <div className={styles.statValue}>{statistics.withIntent}</div>
          <div className={styles.statLabel}>With Intent</div>
        </div>
        <div className={styles.statItem}>
          <div className={styles.statValue}>{statistics.noIntent}</div>
          <div className={styles.statLabel}>No Intent</div>
        </div>
        <div className={styles.statItem}>
          <div className={styles.statValue}>{statistics.avgMessages}</div>
          <div className={styles.statLabel}>Avg Messages</div>
        </div>
      </div>
    </div>
  )
}

export default StatsPanel

